export const getUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user_info'));
    if (!user) {
      throw new Error('No user found');
    }
    return user;
  } catch (error) {
    console.error('Error getting user:', error);
    return { id: 0 }; // Return default user object
  }
};
